import http from '@/utils/http'

// URL and endpoint constants
const API_URL = process.env.API_BASE_URL
const INTERESTED_TYPES = {
  'ALUNO': 'A',
  'FORNECEDOR': 'F',
  'CURSO': 'K',
  'ENTIDADE_EXTERNA': 'O',
  'SERVIDOR': 'S',
  'UNIDADE': 'U',
  'CONTRIBUINTE': 'C',
  'REQUERENTE_EXTERNO': 'Q',
  'PENSIONISTA': 'P'
}

const getListaUnidadesProcedencia = (somenteAtivas) => {
  const UNIDADES_AUTUACAO_URL = API_URL + 'procedencias/UNIDADE'
  let config = {
    method: 'get',
    url: UNIDADES_AUTUACAO_URL,
    responseType: 'json',
    credentials: true,
    params: {
      somenteAtivas: somenteAtivas
    }
  }
  return http(config)
}

const getListaTipoInteressado = (idTipoDocumento) => {
  const INTERESTED_TYPES_URL = API_URL + 'interessados'
  let params = {}
  if (idTipoDocumento) params.idTipoDocumento = idTipoDocumento
  let config = {
    method: 'get',
    url: INTERESTED_TYPES_URL,
    responseType: 'json',
    credentials: true,
    params: params
  }
  return http(config)
}

const getListaTipoResponsavelTramitacao = () => {
  const INTERESTED_TYPES_URL = API_URL + 'responsaveis-tramitacao'
  let config = {
    method: 'get',
    url: INTERESTED_TYPES_URL,
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const getListaEntidadeInteressada = (tipoInteressado, tipoBusca, nome, codigo, somenteAtivos) => {
  const INTERESTED_ENTITIES_URL = API_URL + 'interessados/' + tipoInteressado
  let params = {}
  if (tipoBusca === 'nome') params.nome = nome
  if (tipoBusca === 'codigo') params.codigo = codigo
  params.somenteAtivos = somenteAtivos
  let config = {
    method: 'get',
    url: INTERESTED_ENTITIES_URL,
    params: params,
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const getListaEntidadeResponsavelTramitacao = (tipoResponsavelTramitacao, tipoBusca, nome, codigo) => {
  const INTERESTED_ENTITIES_URL = API_URL + 'responsaveis-tramitacao/' + tipoResponsavelTramitacao
  let params = {}
  if (tipoBusca === 'nome') params.nome = nome
  if (tipoBusca === 'codigo') params.codigo = codigo
  let config = {
    method: 'get',
    url: INTERESTED_ENTITIES_URL,
    params: params,
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const getListaTiposAssunto = (documentType) => {
  const SUBJECT_LIST_URL = API_URL + 'tipos-documentos/' + documentType + '/assuntos'
  let config = {
    method: 'get',
    url: SUBJECT_LIST_URL,
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const getAssuntos = (idTipoDocumento) => {
  let config = {
    method: 'get',
    url: API_URL + 'assuntos',
    responseType: 'json',
    credentials: true,
    params: idTipoDocumento ? {idTipoDocumento: idTipoDocumento} : undefined
  }
  return http(config)
}

const getAssunto = (idAssunto) => {
  let config = {
    method: 'get',
    url: API_URL + `assuntos/${idAssunto}`,
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const getItensGlossario = () => {
  const SUBJECT_LIST_URL = API_URL + 'glossario'
  let config = {
    method: 'get',
    url: SUBJECT_LIST_URL,
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const enviarAutuacao = (idDocumento, bodyAutuacao) => {
  bodyAutuacao.tipoInteressado = INTERESTED_TYPES[bodyAutuacao.tipoInteressado]
  let config = {
    method: idDocumento ? 'patch' : 'post',
    url: API_URL + `documentos${idDocumento ? '/' + idDocumento : ''}`,
    responseType: 'json',
    credentials: true,
    body: bodyAutuacao
  }
  return http(config)
}

const getDocumentoOrigem = (numeroDocumento) => {
  let config = {
    method: 'get',
    url: API_URL + 'documentos',
    params: {
      numeroDocumento: numeroDocumento
    },
    responseType: 'json',
    credentials: true
  }
  return http(config)
}
export default {
  getListaUnidadesProcedencia,
  getListaTipoInteressado,
  getListaTipoResponsavelTramitacao,
  getListaEntidadeInteressada,
  getListaEntidadeResponsavelTramitacao,
  getListaTiposAssunto,
  getDocumentoOrigem,
  enviarAutuacao,
  getAssuntos,
  getAssunto,
  getItensGlossario
}
